import { useEffect, useState } from 'react';
import { useEventCallback } from '@mssgme/hooks';

/**
 * @param {import('formik').FormikProps} formik
 */
export function useAutoSave(formik) {
    const [touched, setTouched] = useState(null);
    const [success, setSuccess] = useState({});

    const handleBlur = useEventCallback((e) => {
        setTouched((prev) => ({ ...prev, [e.target.name]: true }));
        formik.handleBlur(e);
    });

    const handleEnter = useEventCallback((e) => {
        if (e.key === 'Escape'|| e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            e.target.blur?.();
        }
    });

    const getFieldProps = (name) => {
        const { error } = formik.getFieldMeta(name);

        return {
            ...formik.getFieldProps(name),
            onBlur: handleBlur,
            onKeyDown: handleEnter,
            error,
        };
    };

    useEffect(() => {
        if (formik.dirty && touched && Object.keys(touched).length) {
            void formik.submitForm();
        }
    }, [touched]);

    useEffect(() => {
        if (formik.status !== 'success') {
            return;
        }

        setTouched(null);

        const newSuccess = { ...touched };
        setSuccess((prev) => ({ ...prev, ...touched }));

        formik.resetForm({ values: formik.values });

        const timer = setTimeout(() => {
            setSuccess((prev) => {
                const newState = { ...prev };

                for (let prop in newSuccess) {
                    newState[prop] = false;
                }

                return newState;
            });
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, [formik.status]);

    return { getFieldProps, success };
}
